export default "__VITE_ASSET__1f39b0e4__"